import { DialogueUIOptionConfig } from "../../components/ui/YouRespondUI";
import BaseScenarioPart from "../../cvp-webgames-core/Scenario/BaseScenarioPart";
import { Segments } from "../../cvp-webgames-core/Scenario/Segments";
import { constants } from "../../misc/constants";
import { CalmBaseScenario } from "../CalmBaseScenario";
import Scenario5 from "./Scenario5";

export default class Scenario5Part5 extends BaseScenarioPart<CalmBaseScenario> {

	private partIndx = 0;
	chapterIds = {
		
		scenario5_1C_s18: 'CALM - Scenario 5 - 1C - Segment 18',
		scenario5_4C_s19: 'CALM - Scenario 5 - 4C - Segment 19',
		
	}

	constructor(scenario: Scenario5, private onDone: () => void) {
		super(scenario);
		CalmBaseScenario.partIndx = this.partIndx;
	}

	public get videoUrl(): string[] {
		return ['./assets/videos/scenario5/calm-scenario5-avatar' + this.scenario.avatarIndx + '.mp4'];
	}

	public get partId(): string {
		return constants.scenarios.scenario5.parts.level5Part8.id;
	}

	public start() {
		const context = this;
		context.segment1Step1HeatherApproaches();
	}

	private segment1Step1HeatherApproaches() {
		this.scenario.destroyAllUIInstances();
		var context = this;
		context.scenario.displayHeader();
		context.playVideoChapter(this.chapterIds.scenario5_1C_s18, () =>
			context.segment2Step1HeatherDeparts())
	}	

	private segment1Step2Dialogue() {
		this.scenario.destroyAllUIInstances();
		var context = this;
		this.scenario.dialog(
			'CN-C08-L2-090a',
			[{
				text: 'You\'re welcome.',				
				isCorrect: true // Rank Zero
			}],
			(selectedOption: DialogueUIOptionConfig) => {
				selectedOption.hide = true; // set hide here				
				context.scenario.evaluateAnswer(selectedOption, () => 
				context.segment2Step1HeatherDeparts(), 
				context.partIndx);				
			}
		);
		context.scenario.updateObjective('Select your response to Miranda');
	}

	private segment2Step1HeatherDeparts() {
		this.scenario.destroyAllUIInstances();
		var context = this;
		context.scenario.displayHeader();
		context.playVideoChapter(this.chapterIds.scenario5_4C_s19, () =>			
		context.onDone())
	}	
}